import api from './api.service';

const getList = async params => api.catchError(async () => {
  const { data } = await api.get('/stripe-invoices', params);
  return data;
});

export default { getList };




// WEBPACK FOOTER //
// ./src/services/stripeInvoices.service.js